import React from "react";

export const ToolBoxDivider = () => {
  return (
    <svg
      width="2"
      height="20"
      viewBox="0 0 2 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 20L1 -5.96046e-07" stroke="#EDEFF1" />
    </svg>
  );
};
